import { Injectable } from "@angular/core";
import { AuthService } from "./permission";

@Injectable({ providedIn: 'root' })
export class StateService {
  private stateData: Map<string,any> = new Map<string,any>();
  constructor(private authService: AuthService) {
  }
  // Store the form data here

  setStateData(key: string, data: any) {
    if(this.authService.getUserProfile()) 
      this.stateData.set(key, data);
  }

  getStateData(key: string) {
    return this.stateData.get(key);
  }

  clearStateData() {
    this.stateData.clear();
  }
}